export enum PageOpenIn {
    POPUP = 'popup',
    PAGE = 'page'
}